/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsAssistantDraftDto } from '../../models/as-assistant-draft-dto';
import { GenerateAsAssistantDraftDto } from '../../models/generate-as-assistant-draft-dto';

export interface AsControllerGenerateClientAssistantDraft$Params {
  clientWorkspaceId: string;
      body: GenerateAsAssistantDraftDto
}

export function asControllerGenerateClientAssistantDraft(http: HttpClient, rootUrl: string, params: AsControllerGenerateClientAssistantDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<AsAssistantDraftDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerGenerateClientAssistantDraft.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AsAssistantDraftDto>;
    })
  );
}

asControllerGenerateClientAssistantDraft.PATH = '/api/v1/as/client/{clientWorkspaceId}/assistant/draft';
